
angular.module('mtic').constant('API_ROUTES', {
    GET: {
      CLASS_AGENDA: "/class/agenda",
      CLASS_CUSTOM_RESOURCES: '/class/custom_module/resource',
      CLASS_INFO: '/class/info',
      CLASS_MEMBERS: '/class/members',
      ARCHIVED_STUDENTS: '/archived/students',
      CLASS_MODULES: "/class/modules",
      CLASS_RESOURCE_STATES: "/class/resource/states",
      CLASS_SUMMARY_STATS: '/class/modules/summary',
      CLASSES_WITH_MODULES_BY_SCHOOL: '/teacher/school/class',
      COUNTRIES: '/countries',
      NOSCHOOL_CLASSES: "/noschool/classes",
      STUDENT_AGENDA: "/student/agenda",
      STUDENT_APP_EVENTS: "/student/app/events",
      STUDENT_BY_USERNAME_NOSCHOOL: "/noschool/classes/students",
      STUDENT_CLASS_MEMBERS: '/student/class/members',
      STUDENT_CLASSES: "/student/classes",
      STUDENT_CUSTOM_RESOURCES: '/student/custom_module/resource',
      STUDENT_MODULE_RESOURCE_STATE: "/student/module/resource/states",
      TEACHER_SCHOOL_MODULES: '/teacher/school/modules',
      TEACHER_STUDENT_MODULE_RESOURCE_STATE: "/teacher/student/module/resource/states",
      USER_GROUPS: "/user/groups",
      USER_INFO: "/user/info",
      USER_LOGIN: '/user/login',
      VERSION: "/version",
      GET_USER_RESOURCE_APP_STATE: "/user/resource/app/state",
      GET_USER_RESOURCE_LATEST_APP_STATE: "/user/resource/latest/app/state",
      GET_USER_RESOURCE_LAST_APP_STATE:"/user/resource/last/app/state",//SHOULD BE DEPRECATED
      GET_LEADERBOARD:"/leaderboard",      
      GET_LEADERBOARD_TOP_PERFORMER:"/leaderboard/top/student",
      GET_SYNC_LEADERBOARD:"/sync/leaderboard/stats",
      GET_STUDENT_ASSESSMENT_PDF:"/student/assessment/diagnostic/results/pdf",      
      GET_CLASS_ASSESSMENT_DATA:"/class/assessment/diagnostic/results",
      GET_PDF_AVAILABILITY: "/pdf/availability",
      GET_USER_NOTIFICATIONS: "/user/notifications",
      REFRESH_TOKEN:"/access/token",
      CLASS_COUNTRY: "/class/country",
    },
    POST: {
      ACCESS_CODES: "/access_codes",
      AUTH_EVENT: "/user/app/event",
      CLASS_AGENDA: "/class/agenda",
      EVENT: "/app/event",
      GENERAL_LOG: "/random",
      REDEEM_ACCESS_CODE: "/redeem/access_code",
      SCHOOL_MODULE_CLASS: '/teacher/school/class',
      STUDENT_GROUP: "/student/group",
      STUDENT_NO_SCHOOL_ALL: "/multigroup/student",
      STUDENT_NO_SCHOOL: "/group/student",
      STUDENT_RERSOURCE_STATE: "/student/resource/state",
      STUDENT_RERSOURCE_STATE_COPIED: "/copied/student/resource/state",
      STUDENT: "/student",
      TEACHER_THROUGH_GROUP: "/group/teacher",
      TEACHER: "/teacher",
      USER_LOGIN: "/user/login",
      VALID_IAM: "/validate/iam",
      USER_LOGIN_AS: "/user/login/as",
      ARCHIVE_STUDENT: "/student/archive",
      STATE_LOG_SESSION: "/state/log/session",
      IMPORT_AGENDA: "/share/agenda",
      NOTIFICATION_DISMISSED: '/dismiss/notification',
      NOTIFICATION_SEEN: '/markseen/notification',
      NOTIFICATION_ARCHIVE: '/archive/notification',
      POST_NOTIFICATION: '/user/notification',
      POST_RESOURCE_TIME: '/resource/state/timeupdate',
      UPDATE_PASSWORD:'/user/password/update',
      UPDATE_TEACHER_PASSWORD:'/teacher/password/update',
      UPDATE_USER_LANGUAGE: '/user/language/update'
    },
    PUT: {
      GROUP: "/group",
      CLASS_AGENDA: "/class/agenda",
      CLASS_STATE: "/student/fb/class/comment/state",
      LINK_IAM: "/user/auth",
      STUDENT_CLASSES_TRANSFER: "/student/classes/transfer",
      TRANSFER_STUDENT: "/class/student",
      UPDATE_CLASS_ARCHIVE_STATUS:"/class/archive"
    },
    DELETE: {
      ACCESS_CODES: "/access_codes",
      CLASS_AGENDA: "/class/agenda",
      LOGOUT: "/user/login"
    }
  })
